













































































































































































































































































































































































































































































































































































































































import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import {
  DataSet,
  ChartOptions,
  MyOptions,
} from "@/charts/graphData";
import MobileMixin from "@/mixins/mobileMixin";
import CaGraph from "@/homeGraph/CaGraph.vue";
import CaDataBg from "@/homeGraph/CaDataBg.vue";
import BKData from "@/homeGraph/BKData.vue";
import GraphDonut from "@/homeGraph/graph_donut.vue";
import { Site } from "@/shared/Site";
import { User } from "@/shared/User";
import moment from "moment/moment";
import jsonURL from "@/shared/urls";
import apexchart from "vue-apexcharts";
import Doughnut from "@/charts/Doughnut.vue";
import TotalBarGraph from "@/homeGraph/totalBarGraph.vue";
import ChartsCommon from "@/homeGraph/chartsMixin";
import TauxCat from "@/homeGraph/tauxCat.vue";
import TauxCatVendeur from "@/homeGraph/dataDonut.vue";
import {Enseigne} from "@/shared/Enseigne";
import {V2GetAllDataResult, LegacyDataFormat} from "@/types/GetAllData.model";
import store from "@/store/store";

@Component({
  components: {
    CaGraph,
    CaDataBg,
    BKData,
    GraphDonut,
    apexchart,
    Doughnut,
    TotalBarGraph,
    TauxCat,
    TauxCatVendeur,
  },
})
export default class HomeBuffalo extends mixins(
  MyMixin,
  MobileMixin,
  ChartsCommon
) {
  public CAParVendeurs: { [key: string]: number } = {};
  public CAVendeursSeries: number[] = [];
  public donutOptions: ChartOptions = new ChartOptions();
  public remunerationParVendeurs: number[] = [];
  public CouvertsMoyenParVendeurs: { [key: string]: number } = {};
  public CouvertsVendeursSeries: number[] = [];
  public orderSourceSeries: number[] = [];
  public donutLabels: string[] = [];
  public donutLabelsOrderSource: string[] = [];
  public donutOptions2: ChartOptions = new ChartOptions();
  public donutOptions3: ChartOptions = new ChartOptions();
  public donutOptions4: ChartOptions = new ChartOptions();
  public vendeurs: string[] = [];
  public activeVendeurs: string[] = [];
  public activeVendeurs2: string[] = [];
  public activeVendeurs3: string[] = [];
  public barLabels: string[] = [];
  public config: any;
  public tabCA: number[] = [];
  public titleSize: number = this.$vuetify.breakpoint.xs ? 18 : 24;
  public fontSize: number = this.$vuetify.breakpoint.xs ? 16 : 20;
  public offsetX: number = this.$vuetify.breakpoint.xs ? 20 : 0;
  public offsetY: number = this.$vuetify.breakpoint.xs ? 40 : 60;
  public reRender: boolean = false;
  public colors: string[] = [
    "#26A69A",
    "#1976D2",
    "#EF5350",
    "#FFD54F",
    "#7E57C2",
    "#03C9A9",
    "#C0392B",
    "#2574A9",
    "#6C7A89",
    "#1EBC61",
    "#BD02B0",
    "#0057A0",
    "#1EBC61",
    "#870000",
  ];
  public CAParService: { [key: string]: number } = { TOTAL: 0 };
  public CAParEnseignes: { [key: string]: number } = {};
  public CAParOrderSource: { [key: string]: number } = {};
  public TicketsEtCouverts: { [key: string]: string } = {};
  public isRunning: boolean = false;
  public enseigneColor: { [key: string]: string } = {};
  public orderSourceColor: { [key: string]: string } = {};
  public CACouvertsParEnseignes: { [key: string]: number } = {};
  public CATicketsParEnseignes: { [key: string]: number } = {};
  public CATablesParEnseignes: { [key: string]: number } = {};
  public CACouverts: number = 0;
  public CAEnCours: number = 0;
  public CouvertsEnCours: number = 0;
  public TablesEnCours: number = 0;
  public hasCommandesEnCoursData: boolean = false;
  public CAEnCoursParEnseignes: { [key: string]: number } = {};
  public CouvertsEnCoursParEnseignes: { [key: string]: number } = {};
  public TablesEnCoursParEnseignes: { [key: string]: number } = {};
  public cachedV2Data: V2GetAllDataResult[] = [];
  public CATickets: number = 0;
  public CATables: number = 0;
  public nbFinished: number = 0;
  public services: string[] = [];
  public dataSetAll: DataSet = new DataSet();
  public touch: boolean = false;
  public move: any = [];
  public moved: boolean = false;

  @Prop() public myOptions!: MyOptions;
  @Prop() public isTTC!: boolean;

  @Watch("isTTC")
  public onTTCChanged(newValue: boolean, oldValue: boolean) {
    console.log(`HomeBuffalo: isTTC changed from ${oldValue} to ${newValue}, isRunning: ${this.isRunning}`);
    // Ne pas déclencher au premier rendu ou si les valeurs sont identiques
    if (oldValue !== undefined && newValue !== oldValue && !this.isRunning && this.myOptions.site[0] !== undefined) {
      console.log("Triggering TTC reprocess...");
      this.reprocessForTTCChange();
    } else {
      console.log("TTC change ignored - conditions not met");
    }
  }

  @Watch("myOptions.updateMe", { immediate: true, deep: true })
  public onOptionsChanged(value: any, oldValue: any) {
    // console.log(this.myOptions);
    if (!this.isRunning && this.myOptions.site[0] !== undefined) {
      this.init();
    }
  }

  public logic(e: any) {
    const currentMove = this.touch ? e.touches[0].clientX : e.clientX;
    if (this.move.length === 0) {
      this.move.push(currentMove);
    }
    const carousel = document.getElementById("myCarousel");
    const carousel2 = document.getElementById("myCarousel2");
    const touchX = e.touches[0].clientX;
    const touchY = e.touches[0].clientY;
    if (this.move[this.move.length - 1] - currentMove < -100) {
      if (carousel !== null) {
        let top = carousel.getBoundingClientRect().top;
        let bottom = top + carousel.clientHeight;
        let left = carousel.getBoundingClientRect().left;
        let right = left + carousel.clientWidth;
        let prev = carousel.querySelector(".v-window__prev");
        if (prev !== null && left <= touchX && touchX <= right && top <= touchY && touchY <= bottom) {
          const btn: HTMLElement = prev.querySelector(".v-btn") as HTMLElement;
          if (btn !== null) {
            this.moved = true;
            btn.click();
          }
        } else if (carousel2 !== null) {
          top = carousel2.getBoundingClientRect().top;
          bottom = top + carousel2.clientHeight;
          left = carousel2.getBoundingClientRect().left;
          right = left + carousel2.clientWidth;
          prev = carousel2.querySelector(".v-window__prev");
          if (prev !== null && left <= touchX && touchX <= right && top <= touchY && touchY <= bottom) {
            const btn: HTMLElement = prev.querySelector(".v-btn") as HTMLElement;
            if (btn !== null) {
              this.moved = true;
              btn.click();
            }
          }
        }
      }
      this.touch = false;
    } else if (this.move[this.move.length - 1] - currentMove > 100) {
      if (carousel !== null) {
        let top = carousel.getBoundingClientRect().top;
        let bottom = top + carousel.clientHeight;
        let left = carousel.getBoundingClientRect().left;
        let right = left + carousel.clientWidth;
        let next = carousel.querySelector(".v-window__next");
        if (next !== null && left <= touchX && touchX <= right && top <= touchY && touchY <= bottom) {
          const btn: HTMLElement = next.querySelector(".v-btn") as HTMLElement;
          if (btn !== null) {
            btn.click();
            this.moved = true;
          }
        } else if (carousel2 !== null) {
          top = carousel2.getBoundingClientRect().top;
          bottom = top + carousel2.clientHeight;
          left = carousel2.getBoundingClientRect().left;
          right = left + carousel2.clientWidth;
          next = carousel2.querySelector(".v-window__next");
          if (next !== null && left <= touchX && touchX <= right && top <= touchY && touchY <= bottom) {
            const btn: HTMLElement = next.querySelector(".v-btn") as HTMLElement;
            if (btn !== null) {
              btn.click();
              this.moved = true;
            }
          }
        }
      }
      this.touch = false;
    }
  }

  public async init() {
    this.$store.dispatch("login/setLoading", true);
    this.isRunning = true;
    this.nbFinished = 0;
    this.services = [];

    // For touch devices
    document.addEventListener("touchmove", (e: any) => {
      this.touch = true;
      if (!this.moved) {
        this.logic(e);
      }
    });
    window.addEventListener("touchend", (e) => {
      this.moved = false;
      this.move = [];
    });

    this.config = {
      site: this.getGlobal ? this.myOptions.site : this.myOptions.site[0],
      periode: "J",
      date: moment(this.myOptions.date).format("YYYY-MM-DD"),
      profit: [],
      localisation: "",
      service: this.myOptions.service,
      client: this.client,
      heureCourante:
        moment(this.myOptions.date).format("YYYY-MM-DD") ===
        moment(Date.now()).format("YYYY-MM-DD")
          ? true
          : false,
    };

    this.CAParVendeurs = {};
    this.CouvertsMoyenParVendeurs = {};
    this.activeVendeurs = [];
    this.activeVendeurs3 = [];
    this.barLabels = [];
    this.CAVendeursSeries = [];
    this.CouvertsVendeursSeries = [];

    const url = this.isTTC ? jsonURL.getAllData : jsonURL.getAllDataHT;
    this.$emit("update", this.myOptions.site, JSON.stringify(this.myOptions.date), this.myOptions.service);

    const wsEndpoint = "V2/getAllData"; // Plus de distinction TTC/HT ici

    if (this.client === "BK" || !this.getGlobal) {
      this.hasCommandesEnCoursData = false;
      await this.$store
        .dispatch("home/getHomeData", {
          config: this.config,
          WS: url
        })
        .then((data: { [key: string]: any }) => {
          this.processLegacyData(data);
        });
    } else {
      await this.$store
        .dispatch("home/getHomeDataV2", {
          config: this.config,
          WS: wsEndpoint
        })
        .then((v2Data: V2GetAllDataResult[]) => {
          this.cachedV2Data = v2Data;
          this.processV2Data();
        });
    }

    await this.completeInit();
  }

  public processLegacyData(data: { [key: string]: any }) {
    let enseigneCounter = 1;
    this.tabCA = [];
    this.donutLabels = [];
    this.CAParService = { TOTAL: 0 };
    this.CAParEnseignes = {};
    this.CACouvertsParEnseignes = {};
    this.CATicketsParEnseignes = {};
    this.CATablesParEnseignes = {};
    this.CAParOrderSource = {};
    this.donutLabelsOrderSource = [];
    this.orderSourceSeries = [];
    this.CACouverts = 0;
    this.CATickets = 0;
    this.CATables = 0;

    this.CAEnCours = 0;
    this.CouvertsEnCours = 0;
    this.TablesEnCours = 0;
    this.CAEnCoursParEnseignes = {};
    this.CouvertsEnCoursParEnseignes = {};
    this.TablesEnCoursParEnseignes = {};
    this.TicketsEtCouverts = {
      "TOTAL": "0/0/0",
      "Hier": "0/0/0",
      "Semaine dernière": "0/0/0",
      "Mois dernier": "0/0/0",
      "Année dernière": "0/0/0",
    };

    for (let key of Object.keys(data).sort()) {
      const splittedData = data[key];
      const value = parseFloat(splittedData[3]);
      const nbCouverts = parseInt(splittedData[2]);
      const nbTickets = parseInt(splittedData[0]);
      const nbTables = parseInt(splittedData[1]);
      key = key
        .replace(/%20/g, " ")
        .replace(/%C3%B4/g, "ô")
        .replace(/%C3%A9/g, "é");
      const splittedKey = key.split("/");
      let profit = splittedKey[0];
      const tag = splittedKey[1];
      const vendeur = splittedKey[2];
      const service = splittedKey[3].trim();
      if (["GLOBAL", service].includes(this.myOptions.service)) {
        this.TicketsEtCouverts["TOTAL"] = this.TicketsEtCouverts["TOTAL"]
          .split("/")
          .map((num, idx) =>
            (Number(num) + Number(splittedData[idx])).toString()
          )
          .join("/");
        this.CAParService["TOTAL"] += value;
        if (vendeur in this.CAParVendeurs && vendeur[0] !== "@") {
          this.CAParVendeurs[vendeur] += value;
          this.CouvertsMoyenParVendeurs[vendeur] += nbCouverts;
        } else if (vendeur[0] !== "@") {
          this.CAParVendeurs[vendeur] = value;
          this.CouvertsMoyenParVendeurs[vendeur] = nbCouverts;
        }
        for (const word of tag.split("&")) {
          if (word.split("=")[0] === "enseigne") {
            const enseigne = word.split("=")[1];
            if (enseigne.toLowerCase() !== "bun meat bun") {
              if (!(enseigne in this.TicketsEtCouverts)) {
                this.TicketsEtCouverts[enseigne] = splittedData
                  .slice(0, 3)
                  .join("/");
              } else {
                this.TicketsEtCouverts[enseigne] = this.TicketsEtCouverts[
                  enseigne
                ]
                  .split("/")
                  .map((num, idx) =>
                    (Number(num) + Number(splittedData[idx])).toString()
                  )
                  .join("/");
              }
            }
            if (!(enseigne in this.CAParOrderSource)) {
              if (enseigne in this.CAParEnseignes) {
                this.CAParEnseignes[enseigne] += value;
              } else {
                this.CAParEnseignes[enseigne] = value;
              }
              if (nbCouverts !== 0) {
                if (enseigne in this.CACouvertsParEnseignes) {
                  this.CACouvertsParEnseignes[enseigne] += value;
                } else {
                  this.CACouvertsParEnseignes[enseigne] = value;
                }
              }
              if (nbTickets !== 0) {
                if (enseigne in this.CATicketsParEnseignes) {
                  this.CATicketsParEnseignes[enseigne] += value;
                } else {
                  this.CATicketsParEnseignes[enseigne] = value;
                }
              }
              if (nbTables !== 0) {
                if (enseigne in this.CATablesParEnseignes) {
                  this.CATablesParEnseignes[enseigne] += value;
                } else {
                  this.CATablesParEnseignes[enseigne] = value;
                }
              }
            }
          }
          if (word.split("=")[0] === "webordersource") {
            const enseigne = word.split("=")[1].replace(/%26/g, "&");
            if (!(enseigne in this.TicketsEtCouverts)) {
              this.TicketsEtCouverts[enseigne] = splittedData
                .slice(0, 3)
                .join("/");
            } else {
              this.TicketsEtCouverts[enseigne] = this.TicketsEtCouverts[
                enseigne
              ]
                .split("/")
                .map((num, idx) =>
                  (Number(num) + Number(splittedData[idx])).toString()
                )
                .join("/");
            }
            if (!(enseigne in this.CAParEnseignes)) {
              if (enseigne in this.CAParOrderSource) {
                this.CAParOrderSource[enseigne] += value;
                this.orderSourceSeries[enseigneCounter - 2] += value;
              } else {
                this.CAParOrderSource[enseigne] = value;
                this.orderSourceSeries.push(value);
                this.donutLabelsOrderSource.push(enseigne);
                enseigneCounter++;
              }
            }
          }
          if (word.split("=")[0] === "destination") {
            profit = word.split("=")[1];
            switch (profit) {
              case "EAT_IN":
                profit = "Salle";
                break;
              case "TAKE_OUT":
                profit = "VAE";
                break;
              case "DELIVERY":
                profit = "Livraison";
                break;
              default:
                break;
            }
          }
        }
        if (this.donutLabels.includes(profit)) {
          this.CAParService[profit] += value;
        } else {
          this.CAParService[profit] = value;
          this.donutLabels.push(profit);
        }
        if (profit in this.TicketsEtCouverts) {
          this.TicketsEtCouverts[profit] = this.TicketsEtCouverts[profit]
            .split("/")
            .map((num, idx) =>
              (Number(num) + Number(splittedData[idx])).toString()
            )
            .join("/");
        } else {
          this.TicketsEtCouverts[profit] = splittedData
            .slice(0, 3)
            .join("/");
        }
        if (nbCouverts !== 0) {
          this.CACouverts += value;
        }
        if (nbTickets !== 0) {
          this.CATickets += value;
        }
        if (nbTables !== 0) {
          this.CATables += value;
        }
      }
      if (!this.services.includes(service)) {
        this.services.push(service);
      }
    }
    for (const [key, value] of Object.entries(this.CAParService)) {
      if (key !== "TOTAL") {
        this.tabCA.push(value);
      }
    }

    this.donutLabels.sort(
      (a, b) =>
        this.tabCA[this.donutLabels.indexOf(b)] -
        this.tabCA[this.donutLabels.indexOf(a)]
    );
    this.tabCA.sort((a, b) => b - a);

    this.donutLabels.forEach((value, index) => {
      this.enseigneColor[value] = this.colors[index];
    });
    for (const [key, value] of Object.entries(this.CAParVendeurs)) {
      this.CAVendeursSeries.push(value);
      this.activeVendeurs.push(key);
      this.activeVendeurs3.push(key);
    }
    for (const value of Object.values(this.CouvertsMoyenParVendeurs)) {
      this.CouvertsVendeursSeries.push(value);
    }
    this.CAVendeursSeries.forEach((value, index) => {
      this.CouvertsVendeursSeries[index] =
        value / this.CouvertsVendeursSeries[index];
    });

    this.activeVendeurs.sort(
      (a, b) =>
        this.CAVendeursSeries[this.activeVendeurs.indexOf(b)] -
        this.CAVendeursSeries[this.activeVendeurs.indexOf(a)]
    );
    this.CAVendeursSeries.sort((a, b) => b - a);
    this.activeVendeurs3.sort(
      (a, b) =>
        this.CouvertsVendeursSeries[this.activeVendeurs3.indexOf(b)] -
        this.CouvertsVendeursSeries[this.activeVendeurs3.indexOf(a)]
    );
    this.CouvertsVendeursSeries.sort((a, b) => b - a);

    this.donutLabelsOrderSource.sort(
      (a, b) =>
        this.orderSourceSeries[this.donutLabelsOrderSource.indexOf(b)] -
        this.orderSourceSeries[this.donutLabelsOrderSource.indexOf(a)]
    );
    this.orderSourceSeries.sort((a, b) => b - a);

    this.donutLabelsOrderSource.forEach((value, index) => {
      this.orderSourceColor[value] = this.colors[index];
    });
  }

  public async completeInit() {
    if (
      this.getGlobal &&
      this.client === "BK" &&
      "COMPTOIR" in this.TicketsEtCouverts &&
      !this.isMobile()
    ) {
      await this.$store
        .dispatch("home/getHomeData", {
          config: this.config,
          WS: jsonURL.updateNbTicketsRepasEmployes,
        })
        .then((data: any) => {
          for (const key of Object.keys(data)) {
            const value =
              data[key] !== undefined ? parseFloat(data[key][0]) : 0;
            const tabBuff = [value, 0, 0];
            if (value > 0 && ["GLOBAL", key].includes(this.myOptions.service)) {
              this.TicketsEtCouverts["COMPTOIR"] = this.TicketsEtCouverts[
                "COMPTOIR"
              ]
                .split("/")
                .map((num, idx) =>
                  (Number(num) + Number(tabBuff[idx])).toString()
                )
                .join("/");
              this.TicketsEtCouverts["TOTAL"] = this.TicketsEtCouverts["TOTAL"]
                .split("/")
                .map((num, idx) =>
                  (Number(num) + Number(tabBuff[idx])).toString()
                )
                .join("/");
            }
          }
        });
    }

    this.$emit("services", this.services);

    this.activeVendeurs2 = [];
    if (
      !this.getGlobal ||
      (this.client === "BUFFALO" && this.myOptions.site.length === 1)
    ) {
      await this.$store
        .dispatch("home/getHomeData", {
          config: this.config,
          WS: jsonURL.updateRemunerationParVendeurServicePerso,
        })
        .then((data: any) => {
          this.remunerationParVendeurs = [];
          for (const key of Object.keys(data)) {
            const value =
              data[key] !== undefined ? parseFloat(data[key][0]) : 0;
            const splittedKey = key.split("/");
            const vendeur = splittedKey[0];
            const service = splittedKey[1];
            if (
              value > 0 &&
              ["GLOBAL", service].includes(this.myOptions.service)
            ) {
              this.remunerationParVendeurs.push(value);
              this.activeVendeurs2.push(vendeur);
            }
          }
          this.activeVendeurs2.sort(
            (a, b) =>
              this.remunerationParVendeurs[this.activeVendeurs2.indexOf(b)] -
              this.remunerationParVendeurs[this.activeVendeurs2.indexOf(a)]
          );
          this.remunerationParVendeurs.sort((a, b) => b - a);
        });
    }

    if (!this.isMobile()) {
      this.donutOptions.setTitleTxt("CA par vendeur");
      this.donutOptions2.setTitleTxt("Rémunération par vendeur");
      this.donutOptions3.setTitleTxt("CA par centre de profit");
      this.donutOptions4.setTitleTxt("CA par source de commande");
      this.donutOptions.makeMeADoughnutWithoutLabels();
      this.donutOptions2.makeMeADoughnutWithoutLabels();
      this.donutOptions3.makeMeADoughnutWithoutLabels();
      this.donutOptions4.makeMeADoughnutWithoutLabels();
    } else {
      this.donutOptions.makeMeADoughnutWithoutLabelsAndPercentage();
      this.donutOptions2.makeMeADoughnutWithoutLabelsAndPercentage();
      this.donutOptions3.makeMeADoughnutWithoutLabelsAndPercentage();
      this.donutOptions4.makeMeADoughnutWithoutLabelsAndPercentage();
    }

    this.tabCA = this.tabCA.map((x) => Math.round(x * 100) / 100);
    this.orderSourceSeries = this.orderSourceSeries.map(
      (x) => Math.round(x * 100) / 100
    );
    this.CAVendeursSeries = this.CAVendeursSeries.map(
      (x) => Math.round(x * 100) / 100
    );
    this.remunerationParVendeurs = this.remunerationParVendeurs.map(
      (x) => Math.round(x * 100) / 100
    );
    this.CouvertsVendeursSeries = this.CouvertsVendeursSeries.map(
      (x) => Math.round(x * 100) / 100
    );
    this.dataSetAll.label = "ALL";
    this.dataSetAll.data = new Array();
    this.CouvertsVendeursSeries.forEach((value: number, index: number) => {
      if (value > 0 && value !== Infinity) {
        this.dataSetAll.data.push(value);
        this.barLabels.push(this.activeVendeurs3[index]);
      }
    });

    this.reRender = !this.reRender;
    this.isRunning = false;
    this.$store.dispatch("login/setLoading", false);
    this.$emit("loaded");
  }

  public renderIsReady() {
    this.nbFinished++;
  }

  public processV2Data() {
    this.CAEnCours = 0;
    this.CouvertsEnCours = 0;
    this.TablesEnCours = 0;
    this.CAEnCoursParEnseignes = {};
    this.CouvertsEnCoursParEnseignes = {};
    this.TablesEnCoursParEnseignes = {};
    this.TicketsEtCouverts["COMMANDES EN COURS"] = "0/0/0";

    const transformedData = this.transformV2DataToLegacyFormat(this.cachedV2Data);
    this.processLegacyData(transformedData);

    this.processV2CommandesEnCours(this.cachedV2Data);
  }

  public reprocessForTTCChange() {
    console.log(`HomeBuffalo: Reprocessing data for TTC change: ${this.isTTC}, cached data length: ${this.cachedV2Data.length}`);
    if (this.cachedV2Data.length > 0) {
      // Sauvegarder les valeurs importantes avant le reprocessing
      const previousNbFinished = this.nbFinished;
      const previousReRender = this.reRender;

      this.processV2Data();
      this.completeInit();

      // Restaurer les valeurs importantes
      this.nbFinished = previousNbFinished;
      this.reRender = !previousReRender;

      console.log(`Data reprocessed for TTC: ${this.isTTC}, nbFinished preserved: ${this.nbFinished}`);
    } else {
      console.log("No cached V2 data available for TTC reprocessing");
    }
  }

  public reprocessDataForServiceChange() {
    console.log(`Reprocessing data for service: ${this.myOptions.service}, cached data length: ${this.cachedV2Data.length}`);
    if (this.cachedV2Data.length > 0) {
      this.processV2Data();
      this.completeInit();
    } else {
      console.log("No cached V2 data available for reprocessing");
    }
  }

  private resIdToEnseigne(restaurantId: number): string {
    return this.enseignes.filter((ens: Enseigne) => ens.restaurantId === restaurantId).libelle;
  }

  private processV2CommandesEnCours(v2Data: V2GetAllDataResult[]) {
    v2Data.forEach((item) => {
      const caEnCoursValue = this.isTTC ? item.caEnCours.ttc : item.caEnCours.ht;

      if (caEnCoursValue > 0 || item.nbCouvertsEnCours > 0 || item.nbTablesEnCours > 0) {
        this.hasCommandesEnCoursData = true;

        // Get enseigne name
        const enseigneObj = this.enseignes.find((e: any) => e.restaurantId === item.restaurantId);
        const enseigne = enseigneObj ? enseigneObj.libelle : "";

        // Check if service matches the current filter
        if (["GLOBAL", item.service].includes(this.myOptions.service)) {
          // Update totals
          this.CAEnCours += caEnCoursValue;
          this.CouvertsEnCours += item.nbCouvertsEnCours;
          this.TablesEnCours += item.nbTablesEnCours;

          // Update per enseigne totals
          if (enseigne) {
            if (enseigne in this.CAEnCoursParEnseignes) {
              this.CAEnCoursParEnseignes[enseigne] += caEnCoursValue;
            } else {
              this.CAEnCoursParEnseignes[enseigne] = caEnCoursValue;
            }

            if (enseigne in this.CouvertsEnCoursParEnseignes) {
              this.CouvertsEnCoursParEnseignes[enseigne] += item.nbCouvertsEnCours;
            } else {
              this.CouvertsEnCoursParEnseignes[enseigne] = item.nbCouvertsEnCours;
            }

            if (enseigne in this.TablesEnCoursParEnseignes) {
              this.TablesEnCoursParEnseignes[enseigne] += item.nbTablesEnCours;
            } else {
              this.TablesEnCoursParEnseignes[enseigne] = item.nbTablesEnCours;
            }
          }

          // Update TicketsEtCouverts for COMMANDES EN COURS total
          if ("COMMANDES EN COURS" in this.TicketsEtCouverts && this.TicketsEtCouverts["COMMANDES EN COURS"]) {
            const existing = this.TicketsEtCouverts["COMMANDES EN COURS"].split("/");
            const newTickets = parseInt(existing[0]) + 0; // No tickets for commands in progress
            const newTables = parseInt(existing[1]) + item.nbTablesEnCours;
            const newCouverts = parseInt(existing[2]) + item.nbCouvertsEnCours;
            this.TicketsEtCouverts["COMMANDES EN COURS"] = `${newTickets}/${newTables}/${newCouverts}`;
          } else {
            this.TicketsEtCouverts["COMMANDES EN COURS"] = `0/${item.nbTablesEnCours}/${item.nbCouvertsEnCours}`;
          }
        }
      }
    });
  }

  private transformV2DataToLegacyFormat(v2Data: V2GetAllDataResult[]): LegacyDataFormat {
    const result: LegacyDataFormat = {};
    v2Data.forEach((item) => {
      const centreProfit = item.profit;
      const webOrderSource = item.webOrderSource.length > 0 ? `&webordersource=${item.webOrderSource}` : "";
      const enseigneObj = this.enseignes.find((e: Enseigne) => e.restaurantId === item.restaurantId);
      const enseigne = item.enseigne || (enseigneObj ? enseigneObj.libelle : "");
      const tags = `destination=${centreProfit}&enseigne=${enseigne}&codeAdoria=v${item.restaurantId}${webOrderSource}`;
      const service = item.service;

      const key = `${centreProfit}/${tags}/${item.libVendeur}/${service}/${item.restaurantId}`;

      const caEncaisseValue = this.isTTC ? item.caEncaisse.ttc : item.caEncaisse.ht;

      result[key] = [
        item.nbTickets,
        item.nbTables,
        item.nbCouverts,
        caEncaisseValue,
        item.restaurantId
      ];
    });

    return result;
  }

  get canSearch(): boolean {
    return this.myOptions && this.myOptions.site && this.myOptions.site[0] !== undefined;
  }

  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }

  get user(): User {
    return this.$store.getters["login/user"];
  }

  get getGlobal(): boolean {
    return this.$store.getters["getGlobal"];
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }

  get enseignes(): any {
    return this.$store.getters["login/enseignes"];
  }
}
